import { render, staticRenderFns } from "./SearchStudent.vue?vue&type=template&id=179aa5d0&lang=pug&"
import script from "./SearchStudent.vue?vue&type=script&lang=js&"
export * from "./SearchStudent.vue?vue&type=script&lang=js&"
import style0 from "./SearchStudent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports